/*
Copyright (c) 2020 by Stevie. All Rights Reserved.
*/

import React, { FunctionComponent } from 'react'
import styled from 'styled-components';
import { HeadFont } from '../../libs/base/base-style';
const Container = styled.div`
  display: flex;
`
interface LogoProps {
  src?: string;
  title?: string;
  conternt?: string;
  layout?: 'left' | 'center' | 'right';
}

export const LogoImg: FunctionComponent<LogoProps> = (props) => {
  return (
    <Container style={{ justifyContent: props.layout ? props.layout : 'center' }}>
      <HeadFont color='white'>悦享工具管理</HeadFont>
    </Container>
  )
}
